export default __webpack_public_path__ + "static/media/brand-icons.5818bbd0.ttf";